import { map } from 'rxjs/operators';
import { Component, Input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import { ShopSearchParametersService } from '@core/services/shop-search-parameters/shop-search-parameters.service';
import { ShopSearchParametersModalComponent } from '@shared/modals/shop-search-parameters-modal/shop-search-parameters-modal.component';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';

@Component({
  selector: 'app-shop-search-parameters-overview',
  templateUrl: './shop-search-parameters-overview.component.html',
})
export class ShopSearchParametersOverviewComponent {
  protected readonly parameters$ = this.settingsSelector.selectParameters.pipe(
    map(parameters => this.shopSearchParametersService.retrieveParametersValue(parameters)),
  );
  @Input() textColor: IContentBuilderFieldColor = {
    value: 'neutral-800',
    type: ColorFieldTypesValues.Palette,
  };
  @Input() iconBackgroundColor: IContentBuilderFieldColor = {
    value: 'primary-100',
    type: ColorFieldTypesValues.Palette,
  };
  @Input() iconColor: IContentBuilderFieldColor = {
    value: 'primary-600',
    type: ColorFieldTypesValues.Palette,
  };

  constructor(
    private readonly modalsService: ModalsService,
    private settingsSelector: SettingsStoreSelector,
    private readonly shopSearchParametersService: ShopSearchParametersService,
  ) {}

  openParameters(): void {
    this.modalsService.open(ShopSearchParametersModalComponent.handle);
  }
}
